import React from "react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B101A] text-[#E7E5E4] pt-24 pb-10">
      <div className="container-ed">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="overline text-[10px] mb-6" style={{ color: "#D4B77A" }}>
              Studio Legale
            </div>
            <h3 className="serif text-5xl sm:text-6xl lg:text-7xl xl:text-[96px] leading-[0.92] tracking-tighter">
              Scotti <span className="italic" style={{ color: "#D4B77A" }}>&amp;</span> Bava
            </h3>
            <p className="mt-8 max-w-xl text-white/70 leading-relaxed">
              Diritto del lavoro, diritto civile (locazioni, contratti e recupero
              crediti) e diritto penale. Due sedi, un unico presidio professionale
              tra Piemonte e Abruzzo.
            </p>
          </div>

          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-10">
            <div>
              <div className="overline text-[10px] mb-4" style={{ color: "#D4B77A" }}>
                Sede di Chieti
              </div>
              <p className="text-sm leading-relaxed text-white/80">
                Via Spaventa, 29<br />66100 Chieti (CH)
              </p>
              <a href="tel:3201862530" className="mt-3 block text-sm text-white hover:text-[#D4B77A] transition-colors">
                320.1862530
              </a>
              <a href="mailto:avvscotti@legaliscottibava.eu" className="mt-1 block text-sm text-white/80 hover:text-[#D4B77A] transition-colors break-all">
                avvscotti@legaliscottibava.eu
              </a>
            </div>
            <div>
              <div className="overline text-[10px] mb-4" style={{ color: "#D4B77A" }}>
                Sede di Bra
              </div>
              <p className="text-sm leading-relaxed text-white/80">
                Via Provvidenza, 31<br />12042 Bra (CN)
              </p>
              <a href="tel:3807895960" className="mt-3 block text-sm text-white hover:text-[#D4B77A] transition-colors">
                380.7895960
              </a>
              <a href="mailto:avvbava@legaliscottibava.eu" className="mt-1 block text-sm text-white/80 hover:text-[#D4B77A] transition-colors break-all">
                avvbava@legaliscottibava.eu
              </a>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Studio Legale Scotti &amp; Bava — Tutti i diritti riservati.</p>
          <p>
            Sito informativo — Ai sensi dell'art. 35 del Codice Deontologico Forense.
          </p>
        </div>
      </div>
    </footer>
  );
}
